/* @ngInject */
function archivedTasksService ($rootScope) {
  return {
    open,
    close
  }

  function open () {
    $rootScope.$broadcast('open-archived-tasks')
    jQuery('.archived-tasks').transition('slide left')
    jQuery('.dimmer-archived-tasks').addClass('visible active').removeClass('hidden')
    jQuery('body').css('overflow', 'hidden')
  }

  function close () {
    $rootScope.$broadcast('close-archived-tasks')
    jQuery('.archived-tasks').transition('slide left')
    jQuery('.dimmer-archived-tasks').removeClass('visible active').addClass('hidden')
    jQuery('body').css('overflow', '')
  }
}

export { archivedTasksService }
